module.exports = __webpack_public_path__ + "static/media/logo-lat.d8d38b1c.png";